"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PreviewButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../../Framework/i18n");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
var _Thumbnail = _interopRequireDefault(require("../../Containers/Thumbnail"));
var _PreviewPortal = _interopRequireDefault(require("../PreviewPortal"));
var _excluded = ["width", "areAllDesignAreasEmpty"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _button, _thumbnailGrid, _buttonView;
  return {
    viewsContainer: {
      position: 'absolute',
      bottom: 0
    },
    fullScreenWrapper: {
      display: 'flex;',
      justifyContent: 'center'
    },
    button: (_button = {
      textTransform: 'none',
      left: 'calc(50%)',
      zIndex: 2,
      transform: 'translate(-50%, 0)',
      pointerEvents: 'all'
    }, _defineProperty(_button, theme.breakpoints.down('sm'), {
      zIndex: 5
    }), _defineProperty(_button, '@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 950px)', {
      display: 'none'
    }), _button),
    buttonBottom: {},
    buttonTop: {},
    buttonIcon: {
      paddingRight: 8,
      position: 'relative',
      top: -1
    },
    thumbnailGrid: (_thumbnailGrid = {}, _defineProperty(_thumbnailGrid, theme.breakpoints.between('xs', 'md'), {
      width: 'calc(100% - 360px)',
      // subtract with right toolbar width
      maxWidth: 'calc(100% - 360px)'
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.up('md'), {
      position: 'absolute',
      bottom: 0,
      left: 'calc(50% - 175px)',
      // subtract half of the right sidebar width
      width: 453,
      // 2 x 24 (arrow width) + 425 (carousel width)
      transform: 'translateX(-50%)'
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.down('xs'), {
      width: '100%',
      maxWidth: '100%',
      bottom: '-40px'
    }), _thumbnailGrid),
    buttonView: (_buttonView = {
      textTransform: 'none',
      bottom: 35,
      position: 'absolute',
      left: 'calc(50% - 200px)'
    }, _defineProperty(_buttonView, theme.breakpoints.down('xs'), {
      left: 'calc(50% - 75px)',
      bottom: 0,
      height: 56
    }), _defineProperty(_buttonView, '@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 950px)', {
      display: 'none'
    }), _buttonView)
  };
};
var PreviewButton = exports.PreviewButton = function PreviewButton(_ref) {
  var classes = _ref.classes,
    bottom = _ref.bottom,
    top = _ref.top,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
    targetId: "preview_open"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    component: "div",
    className: (0, _clsx["default"])(classes.button, bottom && classes.buttonBottom, top && classes.buttonTop, (0, _customClassName["default"])('preview-button')),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: classes.buttonIcon
  }, "remove_red_eye"), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: "text"
  }, (0, _i18n.t)('configurator.previewButton'))));
};
var FullScreenView = /*#__PURE__*/function (_React$Component) {
  _inherits(FullScreenView, _React$Component);
  var _super = _createSuper(FullScreenView);
  function FullScreenView() {
    var _this;
    _classCallCheck(this, FullScreenView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      previewOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "openPreview", function () {
      _this.setState({
        previewOpen: true
      }, function () {
        return _this.props.handleOpenPreview();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closePreview", function () {
      _this.setState({
        previewOpen: false
      }, function () {
        return _this.props.handleClosePreview();
      });
    });
    return _this;
  }
  _createClass(FullScreenView, [{
    key: "render",
    value: function render() {
      var previewOpen = this.state.previewOpen;
      var _this$props = this.props,
        hasItems = _this$props.hasItems,
        classes = _this$props.classes,
        children = _this$props.children,
        showPreviewButton = _this$props.showPreviewButton,
        showDesignViewList = _this$props.showDesignViewList,
        width = _this$props.width,
        dialogStyle = _this$props.dialogStyle,
        renderTopPreviewButton = _this$props.renderTopPreviewButton,
        ThumbnailComponent = _this$props.ThumbnailComponent,
        thumbnailProps = _this$props.thumbnailProps,
        thumbnailDotMode = _this$props.thumbnailDotMode,
        renderButtonOnTop = _this$props.renderButtonOnTop;
      var topPreviewButton = renderTopPreviewButton(_objectSpread(_objectSpread({}, this.props), {}, {
        onClick: this.openPreview
      }));
      return previewOpen ? /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.fullScreenWrapper
      }, /*#__PURE__*/_react["default"].createElement(_PreviewPortal["default"], {
        closePreviewMode: this.closePreview,
        thumbnailClick: this.handleViewChange,
        previewOpen: previewOpen,
        hasItems: hasItems,
        dialogStyle: dialogStyle
      }, children)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, topPreviewButton, children, showDesignViewList ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "column",
        justifyContent: "space-between",
        className: (0, _clsx["default"])(classes.viewsContainer, (0, _customClassName["default"])('views'))
      }, showPreviewButton && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 12,
        md: 8,
        className: (0, _clsx["default"])(classes.thumbnailGrid, thumbnailDotMode || (0, _withWidth.isWidthDown)('md', width) ? 'dots-container' : 'image-container')
      }, renderButtonOnTop ? /*#__PURE__*/_react["default"].createElement(ThumbnailComponent, thumbnailProps) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ThumbnailComponent, thumbnailProps), !topPreviewButton && /*#__PURE__*/_react["default"].createElement(PreviewButton, _extends({}, this.props, {
        bottom: true,
        onClick: this.openPreview
      }))))) : !topPreviewButton && showPreviewButton && width !== 'xs' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "column",
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(PreviewButton, _extends({}, this.props, {
        onClick: this.openPreview,
        classes: {
          button: classes.buttonView,
          buttonIcon: classes.buttonIcon
        }
      }))));
    }
  }]);
  return FullScreenView;
}(_react["default"].Component);
_defineProperty(FullScreenView, "defaultProps", {
  showPreviewButton: true,
  renderTopPreviewButton: function renderTopPreviewButton(_ref2) {
    var width = _ref2.width,
      areAllDesignAreasEmpty = _ref2.areAllDesignAreasEmpty,
      props = _objectWithoutProperties(_ref2, _excluded);
    return (0, _withWidth.isWidthDown)('sm', width) && !areAllDesignAreasEmpty && /*#__PURE__*/_react["default"].createElement(PreviewButton, _extends({}, props, {
      top: true
    }));
  },
  ThumbnailComponent: _Thumbnail["default"],
  renderButtonOnTop: false
});
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'lg'
})((0, _styles.withStyles)(styles, {
  name: 'FullScreenView'
})(FullScreenView));